import { useEffect, useState } from "react";
import styles from "./heading.module.scss";
import { motion } from "framer-motion";

export const Heading = () => {
  const [selected, setSelected] = useState("");

  useEffect(() => {
    const sections = document.querySelectorAll(".section-wrapper");

    const options = {
      threshold: 0.3,
    };

    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setSelected(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    sections.forEach((section) => observer.observe(section));
  }, []);

  return (
    <motion.nav
      initial={{ y: -70 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={styles.heading} // Use the updated styles
    >
      <span className={styles.logo}>
        h<span>.</span>
      </span>
      <motion.a
        initial={{ y: -70 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5, delay: 0.0 }}
        href="https://instalily.ai"
        target="_blank"
        className={styles.instalilyLogoContainer}
      >
        <img 
        className={styles.instalilyLogo} src="/instalily-logo.png" alt="Instalily AI" />
      </motion.a>
      <motion.a
        initial={{ y: -70 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        href="#about"
        onClick={() => {
          setSelected("about");
        }}
        className={selected === "about" ? styles.selected : ""}
      >
        About
      </motion.a>
      <motion.a
        initial={{ y: -70 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        href="#events"
        onClick={() => setSelected("events")}
        className={selected === "events" ? styles.selected : ""}
      >
        Events
      </motion.a>
      <motion.a
        initial={{ y: -70 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        href="#contact"
        onClick={() => setSelected("contact")}
        className={selected === "contact" ? styles.selected : ""}
      >
        Get Involved
      </motion.a>
    </motion.nav >
  );
};
